var _path, _g, _g2, _g3, _g4, _g5, _g6, _path2, _path3, _circle, _path4, _path5, _circle2, _path6, _circle3, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _g7, _g8, _g9;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobSearchImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200.278,
    height: 215.666,
    viewBox: "0 0 200.278 215.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_2601",
    "data-name": "Group 2601",
    transform: "translate(-742.423 -259.879)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1458",
    "data-name": "Path 1458",
    d: "M920.85,406.818a38.522,38.522,0,0,1-9.582,4.517c-1.389.432-2.785.834-4.183,1.215q-1.734.476-3.476.917c-3.3.853-6.611,1.673-9.874,2.668-1.492.449-2.973.938-4.44,1.483a79.089,79.089,0,0,0-12.607,5.979c-2.75,1.619-10.586,9.575-13.206,9.584h0l-8.863.019c-.158,0-.315,0-.477,0l-2.214,0h-.009c-6.99.017-15.942.035-23.324.052-1.269,0-2.5.007-3.655.009-3.892.007-7.058.014-8.809.019-.959,0-29.858-10.729-43.229-22.165a90.718,90.718,0,0,1-13.072-13.683l-.014-.019a72.213,72.213,0,0,1-14.732-34.963,81.144,81.144,0,0,1,2.357-31.325c3.84-14.567,11.2-28.14,22.546-38.2,14.553-12.9,33.778-18.748,52.813-20.673,13.5-1.368,28.018-2.148,40.921,2.849,15.234,5.9,20.68,19.717,29.6,32.182,10.816,15.115,30.575,19.968,40.117,36.387C945.368,364.193,940.67,393.849,920.85,406.818Z",
    transform: "translate(2.773 15.322)",
    fill: "#cbe3f4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2589",
    "data-name": "Group 2589",
    transform: "translate(893.617 259.879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2586",
    "data-name": "Group 2586",
    transform: "translate(9.287 15.826)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1774",
    "data-name": "Rectangle 1774",
    width: 33.324,
    height: 62.825,
    rx: 6.221,
    fill: "#eff3f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1459",
    "data-name": "Path 1459",
    d: "M836.457,285.734v22.057a4.714,4.714,0,0,1-4.7,4.7H817.451a4.715,4.715,0,0,1-4.7-4.7V276.055s4.48-2.731,13.493,5.189C831.367,285.748,833.522,286.192,836.457,285.734Z",
    transform: "translate(-807.942 -254.476)",
    fill: "#d9dfe5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2587",
    "data-name": "Group 2587",
    transform: "translate(0.82 0.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1460",
    "data-name": "Path 1460",
    d: "M809.285,419.741H807.1V265.073a4.859,4.859,0,0,1,4.851-4.853h16.381a4.861,4.861,0,0,1,4.853,4.853v10.033H831V265.073a2.67,2.67,0,0,0-2.668-2.668H811.953a2.67,2.67,0,0,0-2.668,2.668Z",
    transform: "translate(-807.102 -260.22)",
    fill: "#dcdddf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2588",
    "data-name": "Group 2588"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1461",
    "data-name": "Path 1461",
    d: "M808.664,423.48a1.911,1.911,0,0,1-1.911-1.913V265.529a6.08,6.08,0,0,1,4.917-5.608,1.911,1.911,0,1,1,.794,3.739,2.213,2.213,0,0,0-1.887,2v155.9A1.912,1.912,0,0,1,808.664,423.48Z",
    transform: "translate(-806.753 -259.879)",
    fill: "#1e2b60"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2590",
    "data-name": "Group 2590",
    transform: "translate(895.661 373.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1462",
    "data-name": "Path 1462",
    d: "M835.585,357.105A38.523,38.523,0,0,1,826,361.622c-1.389.432-2.785.834-4.183,1.215q-1.734.476-3.476.917c-3.3.853-6.611,1.673-9.874,2.668-1.427-4.289-1.187-10.2,1.777-17.31.063-.153.129-.3.2-.456q.416-.994.86-1.965c1.025-2.266,2.125-4.442,3.276-6.531a110.91,110.91,0,0,1,17.648-23.508,91.26,91.26,0,0,1,9.507-8.609S845.131,332.35,835.585,357.105Z",
    transform: "translate(-807.623 -308.043)",
    fill: "#1f8790"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1463",
    "data-name": "Path 1463",
    d: "M812.184,355.544a.233.233,0,0,1-.214-.322l17.113-41.016a.232.232,0,0,1,.429.179L812.4,355.4A.233.233,0,0,1,812.184,355.544Z",
    transform: "translate(-801.464 -299.6)",
    fill: "#2a3953"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2591",
    "data-name": "Group 2591",
    transform: "translate(890.403 345.735)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    "data-name": "Path 1464",
    d: "M832.252,348.15c-7.509,26.589-33.008,19.388-25.5-7.2s26.344-44.54,26.344-44.54S839.761,321.562,832.252,348.15Z",
    transform: "translate(-805.386 -296.409)",
    fill: "#1f8790"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_121",
    "data-name": "Line 121",
    d: "M0,52.936a.233.233,0,0,1-.063-.009.232.232,0,0,1-.161-.287L14.66-.063a.232.232,0,0,1,.287-.161.232.232,0,0,1,.161.287L.224,52.766A.233.233,0,0,1,0,52.936Z",
    transform: "translate(8.355 15.34)",
    fill: "#2a3953"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2592",
    "data-name": "Group 2592",
    transform: "translate(780.516 336.056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    "data-name": "Path 1465",
    d: "M785.269,343.732c-4.118,27.32-30.316,23.371-26.2-3.948s20.556-47.492,20.556-47.492S789.387,316.412,785.269,343.732Z",
    transform: "translate(-758.631 -292.291)",
    fill: "#1f8790"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_122",
    "data-name": "Line 122",
    d: "M0,54.385l-.035,0a.232.232,0,0,1-.2-.264L7.932-.035A.232.232,0,0,1,8.2-.23a.232.232,0,0,1,.2.264L.23,54.188A.233.233,0,0,1,0,54.385Z",
    transform: "translate(10.315 15.781)",
    fill: "#2a3953"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2593",
    "data-name": "Group 2593",
    transform: "translate(766.794 340.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1466",
    "data-name": "Path 1466",
    d: "M779.9,341.722c3.824,27.362-22.417,31.028-26.241,3.666s6.2-51.377,6.2-51.377S776.081,314.36,779.9,341.722Z",
    transform: "translate(-752.792 -294.011)",
    fill: "#1f8790"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_123",
    "data-name": "Line 123",
    d: "M7.579,54.47a.232.232,0,0,1-.23-.2L-.23.032a.232.232,0,0,1,.2-.262.232.232,0,0,1,.262.2L7.809,54.205a.232.232,0,0,1-.2.262Z",
    transform: "translate(9.144 15.845)",
    fill: "#2a3953"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2594",
    "data-name": "Group 2594",
    transform: "translate(742.423 376.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    d: "M787.852,334.161c20.057,19,1.836,38.234-18.222,19.235s-27.207-44.021-27.207-44.021S767.794,315.159,787.852,334.161Z",
    transform: "translate(-742.423 -309.375)",
    fill: "#1f8790"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_124",
    "data-name": "Line 124",
    d: "M39.758,37.895a.232.232,0,0,1-.16-.064L-.16.169A.232.232,0,0,1-.169-.16.232.232,0,0,1,.16-.169L39.918,37.493a.232.232,0,0,1-.16.4Z",
    transform: "translate(11.507 11.088)",
    fill: "#2a3953"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    d: "M890.755,368.563q-1.734.476-3.476.917c-3.3.853-6.611,1.673-9.874,2.668-1.492.449-2.973.938-4.44,1.483a79.089,79.089,0,0,0-12.607,5.979c-2.75,1.619-10.586,9.575-13.206,9.584h0A287.407,287.407,0,0,1,823.5,416.005l-.054.054-.007.009-.009-.009A287.55,287.55,0,0,1,799.8,389.3c-.959,0-29.858-10.729-43.229-22.165l.416-1.3,4.132-12.936,4.482-14.048,4.094-12.818,36.169-21.1,1.666-.971v0l.261-.15h31.292l.258.15v0l1.666.971L874.733,324.6l2.442,1.424,5.579,17.474.759,2.386,2.651,8.289,3.25,10.186Z",
    transform: "translate(19.103 59.31)",
    fill: "#faf5f1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    d: "M807.133,377.837c-.026.12-.054.244-.085.364q-.363,1.526-.865,3.084l0,.021,0,0-.024.056a.242.242,0,0,1-.016.038c-.331.712-2.479,5.319-5.135,10.346-.226.433-.458.867-.693,1.3l-.028.052a96.265,96.265,0,0,1-5.032,8.461,23.458,23.458,0,0,1-2.425,3.065l-.054.054-.007.009-.007-.009-.012-.019-.028-.038-.073-.1a.423.423,0,0,1-.054-.07c-.479-.684-1.939-2.766-3.756-5.565v0c-1.1-1.687-2.325-3.641-3.544-5.7-.021-.042-.047-.085-.071-.125A76.463,76.463,0,0,1,779.3,381.2l-.007-.019s.86-1.1,2.085-2.964c.071-.106.141-.216.211-.329a61.942,61.942,0,0,0,5.065-9.458,33.158,33.158,0,0,0,2.9-12.525c0-.588-.024-1.173-.073-1.751-.35-4.021-1.175-8.656-2.026-13.453-1.154-6.482-2.355-13.258-2.505-19.221a31.064,31.064,0,0,1,.792-8.581c.056-.228.12-.454.188-.675l13.658.136s-2.39,3.925-1.365,12.858a53.183,53.183,0,0,0,1.638,8.174c.287,1.034.595,2.066.914,3.1,1.3,4.24,2.823,8.534,4.148,12.934a67.1,67.1,0,0,1,3.267,17.886A41.991,41.991,0,0,1,807.133,377.837Z",
    transform: "translate(49.779 70.687)",
    fill: "#8a1b61"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_74",
    "data-name": "Ellipse 74",
    cx: 6.965,
    cy: 6.965,
    r: 6.965,
    transform: "translate(835.708 375.132)",
    fill: "#8a1b61"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    d: "M800.861,303.8s9.016,9.013-2.183,25.949l-13.658-14.2Z",
    transform: "translate(57.518 59.31)",
    fill: "#dcdddf"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    "data-name": "Path 1471",
    d: "M780.313,303.8s-9.013,9.013,2.186,25.949l13.657-14.2Z",
    transform: "translate(46.532 59.31)",
    fill: "#dcdddf"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_75",
    "data-name": "Ellipse 75",
    cx: 8.125,
    cy: 8.125,
    r: 8.125,
    transform: "translate(868.35 308.824)",
    fill: "#ffbd96"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    "data-name": "Path 1472",
    d: "M810,301.456l-.04,5.516s-7.375,11.747-15.841,11.747-15.843-11.747-15.843-11.747V301.51Z",
    transform: "translate(48.416 56.141)",
    fill: "#ffbd96"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 8.125,
    cy: 8.125,
    r: 8.125,
    transform: "translate(800.335 308.824)",
    fill: "#ffbd96"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    "data-name": "Path 1473",
    d: "M774.655,288.139a8.93,8.93,0,0,0-.926-2.588,7.249,7.249,0,0,0-1.791-2.136,5.316,5.316,0,0,0-2.517-1.1,14.656,14.656,0,0,1,1.854,1.789c.2.247.39.5.573.754a3.015,3.015,0,0,0-.616-.021,3.332,3.332,0,0,0-1.22.324,3.516,3.516,0,0,0-.536.336,2.749,2.749,0,0,0-.461.475,3.46,3.46,0,0,0,.639.1,4.96,4.96,0,0,0,.583.023c.376.007.731-.019,1.074-.038l1.022-.078.226-.014c.033.059.07.115.1.174a24.192,24.192,0,0,1,1.079,2.268c.329.787.632,1.6.961,2.442A7.308,7.308,0,0,0,774.655,288.139Z",
    transform: "translate(35.909 30.302)",
    fill: "#d88256"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    "data-name": "Path 1474",
    d: "M778.8,308.24s-6.282,48.62,28.408,48.62,29.5-48.62,29.5-48.62,14.478-15.843,10.926-33.052c-1.911-10.379-7.1-8.193-11.744-6.828s-21.033,6.555-30.321-1.093-22.943,2.458-24.584,7.92c0,0-10.106-1.638-12.017,7.923S772.788,304.144,778.8,308.24Z",
    transform: "translate(35.332 6.252)",
    fill: "#2a3953"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1475",
    "data-name": "Path 1475",
    d: "M798.652,288.139a8.928,8.928,0,0,1,.926-2.588,7.251,7.251,0,0,1,1.791-2.136,5.308,5.308,0,0,1,2.517-1.1,14.645,14.645,0,0,0-1.854,1.789c-.2.247-.39.5-.574.754a3.015,3.015,0,0,1,.616-.021,3.332,3.332,0,0,1,1.22.324,3.532,3.532,0,0,1,.536.336,2.766,2.766,0,0,1,.461.475,3.463,3.463,0,0,1-.639.1,4.96,4.96,0,0,1-.583.023c-.376.007-.731-.019-1.074-.038l-1.023-.078-.225-.014c-.033.059-.071.115-.1.174a24.238,24.238,0,0,0-1.079,2.268c-.329.787-.632,1.6-.961,2.442A7.306,7.306,0,0,1,798.652,288.139Z",
    transform: "translate(75.718 30.302)",
    fill: "#d88256"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1476",
    "data-name": "Path 1476",
    d: "M774.723,275.91c4.571.914,8.842,11.89,23.78,12.2,7.927,0,11.89-2.44,11.89-2.44s-7.925-3.657-10.365-7.925a20.433,20.433,0,0,0,21.646-.611c1.525.306,5.182,25,0,36.587s-14.33-1.22-22.257.611-17.378,9.756-21.952,3.048S774.723,275.91,774.723,275.91Z",
    transform: "translate(43.125 21.647)",
    fill: "#ffbd96"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1477",
    "data-name": "Path 1477",
    d: "M818.34,352.969l8.193,1.911c-.957,9.923-9.027,22.88-17.8,34.312A287.408,287.408,0,0,1,785.077,416l-.054.054c.773-1.062,1.528-2.127,2.254-3.192q2.87-4.192,5.258-8.388l.028-.052a117.832,117.832,0,0,0,5.829-11.648.271.271,0,0,0,.016-.038l.023-.056.009-.024q.751-1.731,1.427-3.45c17.152-43.515,2.148-82.521,1.053-85.256v0a1.588,1.588,0,0,1-.059-.148c.583.36,1.161.733,1.725,1.121,18.4,12.647,25.86,40.669,25.86,40.669Z",
    transform: "translate(57.522 59.311)",
    fill: "#dcdddf"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    "data-name": "Path 1478",
    d: "M809.953,416.039l.009.019A287.557,287.557,0,0,1,786.335,389.3c-8.806-11.458-16.924-24.464-17.883-34.415l8.2-1.911-10.106-7.375S774,317.572,792.4,304.925q.85-.582,1.727-1.121c0,.014-.026.063-.061.148v0c-1.1,2.736-16.116,41.779,1.079,85.322q.649,1.639,1.359,3.283l.007.019a117.975,117.975,0,0,0,5.918,11.855c.024.04.049.082.07.125a124.4,124.4,0,0,0,7.3,11.27.427.427,0,0,0,.054.07.926.926,0,0,0,.073.1Z",
    transform: "translate(32.566 59.311)",
    fill: "#dcdddf"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    d: "M785.019,351.741l0-.138-.115.1-.307-.306h.515l.06.085-.15.124Z",
    transform: "translate(57.513 123.804)",
    fill: "#00446d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    d: "M794.514,325.224c-7.425-1.946-10.912-8.061-12.48-12.32.056-.228.12-.454.188-.675l13.657.136S793.489,316.29,794.514,325.224Z",
    transform: "translate(53.486 70.687)",
    fill: "#f09dd3",
    opacity: 0.4,
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2596",
    "data-name": "Group 2596",
    transform: "translate(834.728 392.172)",
    opacity: 0.4,
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2595",
    "data-name": "Group 2595"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    d: "M801.67,344.119a39.425,39.425,0,0,1-17.467-8.731c-1.154-6.482-2.355-13.258-2.505-19.221,2.606,3.946,8.118,11.131,15.824,15.018C798.823,335.425,800.344,339.719,801.67,344.119Z",
    transform: "translate(-781.697 -316.167)",
    fill: "#f09dd3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2598",
    "data-name": "Group 2598",
    transform: "translate(836.43 426.596)",
    opacity: 0.4,
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2597",
    "data-name": "Group 2597"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    "data-name": "Path 1482",
    d: "M802.819,353.106c-7.15-.959-14.062-4.261-20.4-9.768a33.16,33.16,0,0,0,2.9-12.525c4.317,4.884,10.694,10.212,18.635,11.413A42.037,42.037,0,0,1,802.819,353.106Z",
    transform: "translate(-782.421 -330.814)",
    fill: "#f09dd3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2600",
    "data-name": "Group 2600",
    transform: "translate(829.069 448.908)",
    opacity: 0.4,
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2599",
    "data-name": "Group 2599"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    "data-name": "Path 1483",
    d: "M801,353.835a103.962,103.962,0,0,1-5.753,9.815,37.23,37.23,0,0,1-6.416-2.677v0c-3.2-4.931-7.5-12.078-9.54-17.7,0,0,.86-1.1,2.085-2.964C785.466,345.494,792.239,352.145,801,353.835Z",
    transform: "translate(-779.289 -340.307)",
    fill: "#f09dd3"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobSearchImage);
export default __webpack_public_path__ + "static/media/job-search-image.0c342023c7d60a2e8faad0119bfdb685.svg";
export { ForwardRef as ReactComponent };